export { FdcAuthor } from "./pages/fdcAuthorManagement";
